import { render, staticRenderFns } from "./AssignCoproprieteModal.vue?vue&type=template&id=2e93f224"
import script from "./AssignCoproprieteModal.vue?vue&type=script&lang=ts"
export * from "./AssignCoproprieteModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports